import React from "react";
import { CircularProgress } from "@mui/material";

function CancelBooking({ onClose, cancelBooking, loading, isSelectedData }) {
  
  const handleSubmit = (e) => {
    e.preventDefault();
    cancelBooking();
  };

  return (
    <div>
      <div className="modal-backdrop show"></div>

      <div
        className="modal show d-block"
        tabIndex="-1"
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-header border-bottom-0 py-2">
              <h6 className="modal-title fw-semibold">Cancel Booking</h6>
              <button
                type="button"
                className="btn-close border"
                onClick={onClose}
              ></button>
            </div>

            <div className="modal-body">
              <p className="fw-semibold text-center">
                Are you sure you want to cancel this booking?
              </p>

              <p className="text-muted text-center mb-0">
                Booking ID: <strong>{isSelectedData?.bookingNumber}</strong>
              </p>
            </div>
         
            <div className="modal-footer border-top-0 d-flex justify-content-end gap-2">

              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
              >
                No
              </button>

              {loading?.cancelBooking ? (
                <button className="btn btn-danger" disabled>
                  <CircularProgress size={20} className="text-white" />
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleSubmit}
                >
                  Yes
                </button>
              )}

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CancelBooking;
